// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyProps } from "@insite/mobius/Typography";
import { pointDataStyles } from "@stoneage/App/Components/ProductDetails/PointData";
import { color, ellipsis } from "@stoneage/XDL/Utilities";
import { css } from "styled-components";

pointDataStyles.imageAndDescription = {
    css: css`
        display: flex;
        gap: 16px;
    `,
};

pointDataStyles.productDescription = {
    productDetailLink: {
        typographyProps: {
            weight: "bold",
        },
        css: css`
            margin-bottom: 8px;
        `,
    },
    productDetailDescription: {
        weight: "bold",
        css: css`
            margin-bottom: 8px;
        `,
    },
};

pointDataStyles.buttonWrapper = {
    css: css`
        margin-top: 16px;
        .contact-for-quote-msg {
            display: none;
        }
    `,
};

pointDataStyles.button = {
    sizeVariant: "small",
    typographyProps: {
        css: css`
            &&& {
                text-transform: none;
                font-weight: 500;
            }
        `,
    },
    css: css`
        width: 100%;
        justify-content: center;

        &&& svg {
            stroke-width: 3px;
        }
    `,
};

pointDataStyles.leftPart = {
    css: css`
        width: 80px;
        height: 80px;
    `,
};

pointDataStyles.image = {
    css: css`
        width: 80px;
        height: 80px;
        img {
            width: 100%;
            height: auto;
            border: 1px solid ${color("common.ui5")};
        }
    `,
};
pointDataStyles.productPartNumbers = {
    erpNumberWrapper: {
        css: css`
            span[data-test-selector^="productNumber"] {
                color: ${color("common.ui1")};
            }
        `,
    },
    container: {
        css: css`
            display: flex;
            flex-direction: column;
            row-gap: 4px;
            .item-cont {
                display: flex;
            }
        `,
    },
};
pointDataStyles.priceSavingExtendedStyles = {
    wrapper: {
        css: css`
            display: flex;
            gap: 8px;
            white-space: nowrap;
            align-items: baseline;
        `,
    },
    messageWrapper: {
        css: css`
            display: flex;
            gap: 4px;
            align-items: baseline;
        `,
    },
    label: {
        size: 12,
        color: "text.main",
        weight: "bold",
        lineHeight: "18px",
        css: css`
            opacity: 0.5;
        `,
    },
    price: {
        size: 15,
        color: "text.main",
        weight: "bold",
        lineHeight: "26px",
        css: css`
            opacity: 1;
        `,
    },
    discount: {
        size: 10,
        lineHeight: "15px",
        color: "text.main",
    },
};
pointDataStyles.price = {
    price: {
        priceText: { weight: "bold", color: "common.black", size: 20, lineHeight: "24px" },
    },
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            margin-top: 4px;
        `,
    },
};
pointDataStyles.description = {
    size: 15,
    lineHeight: "19px",
    css: css`
        ${ellipsis(3)};
        margin-bottom: 8px;
    `,
};

const sharedTextStyles: TypographyProps = {
    variant: "p",
    size: 12,
    color: "text",
    css: css`
        letter-spacing: 0;
        line-height: 18px;
        margin-bottom: 0;
        text-transform: none;
    `,
};

pointDataStyles.partNumber = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            width: auto;
        `,
    },
    heading: {
        ...sharedTextStyles,
        css: css`
            ${sharedTextStyles.css}
            display: flex;
            &:after {
                content: ":";
                margin-right: 4px;
            }
        `,
    },
    text: {
        ...sharedTextStyles,
        css: css`
            ${sharedTextStyles.css}
            ${wrapInContainerStyles}
            width: auto;
            font-weight: bold;
            color: ${color("common.black")};
        `,
    },
};
pointDataStyles.priceAndInventoryWrapper = {
    css: css`
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        width: 100%;
    `,
};
pointDataStyles.rightPart = {
    css: css`
        flex-grow: 1;
    `,
};
pointDataStyles.availabilityStyles = {
    messageGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
    availabilityByWarehouseLinkGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
};

pointDataStyles.priceTextStyle = {
    css: css`
        line-height: 24px;
        font-size: 20px;
        font-weight: bold;
        margin-top: 18px;
    `,
};
